import Component from '../abstracts/Component';

export default class ShowPasswordComponent extends Component {

  get SELECTORS() {
    return {
      main: '.toggle-password',
    };
  }

  get CLASSES() {
    return {
      passwordVisible: 'icon-visibility-on',
      passwordNotVisible: 'icon-visibility-off'
    };
  }

  constructor() {
    super();
  }

  bindEvents() {
    this.$on('click', ({event}) => {
      event.preventDefault();
      const input = event.currentTarget.parentElement.querySelector('input');
      const inputType = input.getAttribute('type');

      if (!input.value) return;

      switch (inputType) {
        case 'password':
          input.setAttribute('type', 'text');
          event.currentTarget.classList.remove(this.CLASSES.passwordVisible);
          event.currentTarget.classList.add(this.CLASSES.passwordNotVisible);
          break;
        case 'text':
          input.setAttribute('type', 'password');
          event.currentTarget.classList.remove(this.CLASSES.passwordNotVisible);
          event.currentTarget.classList.add(this.CLASSES.passwordVisible);
          break;
      }
    }, 'body', this.SELECTORS.main);
  }

  render() {
    this.log("Rendering...")
    this.bindEvents();
  }
}
